// !!!Entire file is ignored in UNIT TESTS!!!
// BE VERY CAREFULL IF YOU DECIDED TO TINKER HERE
// going around a TypeScript design limitation
// https://github.com/Microsoft/TypeScript/issues/12949
// dirty logic, no way to test -> related to browser feature detection
// and registering custom tag names as HTMLElements
/**
 * Supplies custom tag names to the defineCustomTags function.
 */
export var customTags = [
    "sb-comp",
    "sb-error-comp",
    "sb-collapsible",
    "sb-collapsible-trigger",
    "sb-collapsible-block",
    "sb-collapsible-content",
    "sb-tabs",
    "sb-tabs-triggers",
    "sb-tab-trigger",
    "sb-tabs-blocks",
    "sb-tabs-block",
    "sb-tabs-content",
    "sb-img"
];
/**
 * Defines custom tags used for wrapping content
 */
export function defineCustomTags() {
    var classes = true;
    if (typeof customElements !== "undefined") {
        try {
            eval("class foo{ constructor(){} }");
        }
        catch (e) {
            classes = false;
        }
        customTags.forEach(function (x) {
            if (classes) {
                eval("window.customElements.define(x, class extends HTMLElement { })");
            }
            else {
                eval("window.customElements.define(x, HTMLElement)");
            }
        });
    }
    return true;
}
;
//# sourceMappingURL=CustomTags.js.map